import cn from 'classnames';
import { t } from 'i18next';

import { arrayHasLength } from '~utils/array';

import { getIngredientsWithMultiplier, getOfferDetail, getPizzaByHalvesIngredients } from './utils';
import styles from './styles.module.scss';

export const getPizzaByHalvesDetails = (item, pizzasSpecialtyData) =>
  Object.entries(getPizzaByHalvesIngredients(item, pizzasSpecialtyData)).map(
    ([side, sideIngredients]) =>
      arrayHasLength(sideIngredients) && (
        <p key={side}>
          <span className={cn(styles.title, styles.side)}>{t(`ProductDetail:${side}`)}</span>
          {getIngredientsWithMultiplier(sideIngredients)}
        </p>
      )
  );

export const getCustomPizzaDetails = item => <p>{getIngredientsWithMultiplier(item?.ingredients)}</p>;

export const getOfferDetails = (item, baseIngredients) =>
  getOfferDetail(item, baseIngredients)?.map(({ id, name, description }) => (
    <div key={id}>
      <p className={cn(styles.offerProductTitle)}>{name}</p>
      <p>{description}</p>
    </div>
  ));
